<template>
  <div class="bodyAnalyze-box">
    <BlockTitle title="交易主体分析" />
    <div class="block-content position-relative d-flex justify-content-between">
      <div id="bodyAnalyzeChart"></div>
      <div id="bodyAnalyzeChart02"></div>
      <div class="chassis"></div>
      <div class="chassis02"></div>
      <!-- <div id="typeChartDom" class="chart-canvas"></div> -->
    </div>
  </div>
</template>

<script>
import BlockTitle from "@/views/public_0983cc/tradeData/components/public/BlockTitle.vue";
import * as echarts from "echarts";
import "echarts-gl"; // 3d图表库
import { portal_data_v2_subject } from "@/api/portal";
import { mapGetters } from "vuex";

export default {
  components: {
    BlockTitle,
  },
  data() {
    return {
      chartInstance: null,
      chartInstance02: null,
      chartData02: {},
      chartData: {},
      colorList: ["#9D45D1", "#1391F8", "#83FFE9", "#91CC75"],
    };
  },
  computed: {
    ...mapGetters(["selectLocId", "selectLocName"]),
    chartDom() {
      return document.getElementById("bodyAnalyzeChart");
    },
    chartDom02() {
      return document.getElementById("bodyAnalyzeChart02");
    },
    charOption() {
      return {
        title: {
          text: '受让方类型占比',
          left: 'center',
          textStyle: {
            color: 'white', // 设置字体颜色
            fontSize: 14  // 设置字体大小
          },
          padding: [0, 20]
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "#033b77",
          borderColor: "#21f2c4",
          textStyle: {
            color: "#fff",
            fontSize: 13,
          },
          formatter: (params) => {
            return (
              `${params.name}<br/>` +
              `<span class="mt-10 d-inline-block" style="margin-right:5px;border-radius:10px;width:10px;height:10px;background:linear-gradient(180deg, ${params.color.colorStops[0].color} 0%, ${params.color.colorStops[1].color} 100%);"></span>` +
              `<span>总数：${params.data.value}</span> ` +
              `<span>占比：${params.percent}%</span> `
            );
          },
        },
        legend: {
          show: true,
          bottom: "-10",
          textStyle: {
            color: "#fff",
            fontWeight: "100",
          },
          itemGap: 15,
          padding: [10, 10]
        },

        series: [
          {
            type: "pie",
            width: "100%",
            height: "80%",
            center: ["50%", "50%"],
            radius: ["30%", "70%"],
            label: {
              normal: {
                position: "outside",
                color: "#fff",
                formatter: (v) => {
                  return v.data.name + v.percent + "%";
                },
                fontWeight: "100",
                show: false,
              },
            },
            labelLine: {
              show: true,
              length: 0,
              length2: 50,
              show: false,
              lineStyle: {
                color: "#27C8FF",
              },
            },
            itemStyle: {
              normal: {
                color: (list) => {
                  var colorList = [
                    {
                      colorStart: "#2BE9FF",
                      colorEnd: "#007EC0",
                    },
                    {
                      colorStart: "#2497FF",
                      colorEnd: "#0137A8",
                    },
                    {
                      colorStart: "#4FD5A6",
                      colorEnd: "#08864B",
                    },
                    {
                      colorStart: "#FFC444",
                      colorEnd: "#A97025",
                    },
                  ];
                  return new echarts.graphic.LinearGradient(1, 1, 0, 0, [
                    {
                      //左、下、右、上
                      offset: 0,
                      color: colorList[list.dataIndex]["colorStart"],
                    },
                    {
                      offset: 1,
                      color: colorList[list.dataIndex]["colorEnd"],
                    },
                  ]);
                },
              },
            },
            data: this.chartData,
          },
        ],
      };
    },
    charOption02() {
      return {
        title: {
          text: '出让方类型占比',
          left: 'center',
          textStyle: {
            color: 'white', // 设置字体颜色
            fontSize: 14  // 设置字体大小
        },
          padding: [0, 20]
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "#033b77",
          borderColor: "#21f2c4",
          textStyle: {
            color: "#fff",
            fontSize: 13,
          },
          formatter: (params) => {
            return (
              `${params.name}<br/>` +
              `<span class="mt-10 d-inline-block" style="margin-right:5px;border-radius:10px;width:10px;height:10px;background:linear-gradient(180deg, ${params.color.colorStops[0].color} 0%, ${params.color.colorStops[1].color} 100%);"></span>` +
              `<span>总数：${params.data.value}</span> ` +
              `<span>占比：${params.percent}%</span> `
            );
          },
        },
        legend: {
          show: true,
          bottom: "-10",
          textStyle: {
            color: "#fff",
            fontWeight: "100",
          },
          itemGap: 15,
          padding: [10, 20]
        },
        series: [
          {
            type: "pie",
            width: "100%",
            height: "80%",
            center: ["50%", "50%"],
            radius: ["30%", "70%"],
            label: {
              normal: {
                position: "outside",
                color: "#fff",
                formatter: (v) => {
                  return v.data.name + v.percent + "%";
                },
                fontWeight: "100",
                show: false,
              },
            },
            labelLine: {
              show: true,
              length: 0,
              length2: 50,
              show: false,
              lineStyle: {
                color: "#27C8FF",
              },
            },
            itemStyle: {
              normal: {
                color: (list) => {
                  var colorList = [
                    {
                      colorStart: "#2BE9FF",
                      colorEnd: "#007EC0",
                    },
                    {
                      colorStart: "#2497FF",
                      colorEnd: "#0137A8",
                    },
                    {
                      colorStart: "#4FD5A6",
                      colorEnd: "#08864B",
                    },
                    {
                      colorStart: "#FFC444",
                      colorEnd: "#A97025",
                    },
                  ];
                  return new echarts.graphic.LinearGradient(1, 1, 0, 0, [
                    {
                      //左、下、右、上
                      offset: 0,
                      color: colorList[list.dataIndex]["colorStart"],
                    },
                    {
                      offset: 1,
                      color: colorList[list.dataIndex]["colorEnd"],
                    },
                  ]);
                },
              },
            },
            data: this.chartData02,
          },
        ],
      };
    }
  },
  watch: {
    async selectLocId() {
      await this.getAnalysis();
      this.initChart();
    },
  },
  created() {},
  async mounted() {
    await this.getAnalysis();
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.chartDom)
      this.chartInstance.setOption(this.charOption)
      this.chartInstance02 = echarts.init(this.chartDom02)
      this.chartInstance02.setOption(this.charOption02)
    },
    // 获取交易类型分析V2
    async getAnalysis() {
      let { data } = await portal_data_v2_subject({
        locId: this.selectLocId,
        locName: this.selectLocName,
      });
      console.log('data',data);
      this.chartData = data.transferee.map((i) => ({
          value: i.count,
          name: i.name,
      }));
      this.chartData02 = data.transfer.map((i) => ({
          value: i.count,
          name: i.name,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.bodyAnalyze-box {
  width: 38.4rem;
  margin-bottom: 16px;
  .block-content {
    height: 12rem;
    .chassis {
      position: absolute;
      width: 1.5rem;
      height: 1rem;
      bottom: 9.65rem;
      right: 6.7rem;
      left: 0;
      margin: 0 auto;
      background: url("~@/assets/images/titleBarZ.png") 0 0 / cover no-repeat;
    }
    .chassis02 {
      position: absolute;
      width: 1.5rem;
      height: 1rem;
      bottom: 9.65rem;
      right: 32.7rem;
      left: 0;
      margin: 0 auto;
      background: url("~@/assets/images/titleBarC.png") 0 0 / cover no-repeat;
    }
  }
  #bodyAnalyzeChart {
    position: relative;
    width: 34%;
    height: 89%;
    z-index: 90;
    margin-left: 0.3rem;
    margin-top: 1.5rem;
  }
  #bodyAnalyzeChart02 {
    position: relative;
    width: 34%;
    height: 89%;
    z-index: 10;
    margin-right: 12rem;
    margin-top: 1.5rem;
  }
}
</style>